import { render, staticRenderFns } from "./EditTenantRelation.vue?vue&type=template&id=70487287"
import script from "./EditTenantRelation.vue?vue&type=script&lang=js"
export * from "./EditTenantRelation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports